import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DEFAULT_ERROR_MESSAGE } from "@merri/common";
import { map, Observable } from "rxjs";
import { PartnerCommands } from "../commands/partner-commands";
import { PostValidatePartnerResponse } from "../responses/partner-responses";
import { AppConfigService } from "./app-config.service";

@Injectable({
  providedIn: "root",
})
export class PartnerService {
  constructor(private _http: HttpClient, private _appConfigService: AppConfigService) {}

  validatePartnerId$(partnerId: number): Observable<string> {
    return this._http
      .post<PostValidatePartnerResponse>(
        this._appConfigService.getConfig().postValidatePartnerApiUrl,
        PartnerCommands.getValidatePartnerCommand(partnerId),
      )
      .pipe(
        map(response => {
          if (!response.success) {
            throw DEFAULT_ERROR_MESSAGE;
          }

          return response.partnerName;
        }),
      );
  }
}
